import axios from '../utils/axios';

export default function fetchApplicationsExcel(adminId, params) {
    return (
        axios.post('/admin/' + adminId + '/recruiter/' + params.recId + '/job/' + params.jobId + '/excel' +"?pageContent=" + params.pageContent + "&offset=" + params.offset)
    )
}
